var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-shrink-0 flex-grow flex-row flex-no-wrap"},[_c('w-segmentation'),_c('w-map',{staticClass:"flex-grow flex-shrink",attrs:{"center":_vm.center,"zoom":_vm.zoom,"markers":_vm.markers}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }